import { atom } from "recoil"
import { UserDetail } from '../connector/type';

export enum PickType {
  NONE = '',
  PAST = 'p',
  MERON = 'm',
  DRAW = 'd',
  WALA = 'w',
}

export interface PickHistoryItem { 
  date: string;
  round: string;
  result: string;
  pick: string; 
}

const defaultUserDetail: UserDetail = {
  id: '',
  nickname: '',
  level: 0,
  hasThumbnail: false,
  todayComment: '',
  gasMask: false,
  familyNickname: '',
}

const roomDetailState = atom({
  key: 'roomDetail',
  default: {
    id: '',
    owner: '',
    participants: 0,
    uniqueParticipants: 0,
    name: '',
    description: '',
    maxParticipants: 0,
    isPremium: false,
    isSecret: false,
    ownerDetail: defaultUserDetail,
    pick: PickType.NONE,
    pickHistory: [{} as PickHistoryItem],
  }
});

export default roomDetailState;